module.exports = __webpack_public_path__ + "static/img/icon_szh_cgal_ny_ywpt@2x.656d0403.png";